<template>
  <section class="ctn">
    <section class="table">
      <heim-table :data="filteredProviders" :columns="['id', 'name']" cols="4">
        <template slot="thead" slot-scope="props">
          <th class="id sortable" @click="props.sortBy('id')">#<heim-icon :icon="props.sortOrders['id'] > 0 ? 'arrow-drop-down':'arrow-drop-up'"></heim-icon></th>
          <th class="sortable main" @click="props.sortBy('name')">{{ $t('provider') }}<heim-icon :icon="props.sortOrders['name'] > 0 ? 'arrow-drop-down':'arrow-drop-up'"></heim-icon></th>
          <th class="">{{ $t('nbServer') }}</th>
          <th class="action activity"></th>
          <th class="action details"></th>
        </template>
        <template slot="tbody" slot-scope="{ item, index }">
          <tr :key="'providers-'+index">
            <td class="id" data-title="#">{{item.id}}</td>
            <td data-title="Servers">
                <span class="label">{{item.name}}</span>
            </td>
            <td>
              <span>{{item.Servers.length}}</span>
            </td>
            <td class="activity" data-title="Activity">
              <router-link class="paper-action" :to="{ path: `/providers/${item.id}` }">
                <heim-icon icon="timeline"></heim-icon><heim-icon class="icon" icon="chevron-right"></heim-icon></router-link>
            </td>
            <td class="details mobile-link"><router-link class="link" :to="{ path: `/providers/${item.id}`}"><heim-icon icon="chevron-right"></heim-icon></router-link></td>
          </tr>
        </template>
      </heim-table>
    </section>
  </section>
</template>

<script>
import HeimIcon from "@/components/icon/heim-icon.vue";
import HeimTable from "@/components/layout/list/heim-table.vue";
import { mapState } from "vuex";
import fuseMixin from "@/mixins/fuse";

export default {
  name: "ProvidersList",
  components: {
    HeimIcon,
    HeimTable
  },
  mixins: [fuseMixin],
  mounted() {
    this.$store.dispatch("getProviders");
    // we need to setup fuse inside a watcher
    // because otherwise fuse setups itselfs
    // with an empty array (no data has arrived yet)
    this.$watch(
      vm => vm.providers,
      val => {
        this.setupProviders();
      }
    );
    this.setupProviders();

    this.$store.dispatch("setTitle", "Providers");
  },
  computed: {
    ...mapState(["search"]),
    ...mapState({ providers: state => state.providersState.providers })
  }
};
</script>

<style scoped>
.disabled {
  color: #8b969c;
}
</style>
